import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import AxiosInstance from "../../components/Axios";
import {MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState} from "material-react-table";
import {
    AgentiApiResponse, mapJsonToAgentiApiResponse,
    mapJsonToReportAgentiVersoreApiResponse, ReportAgentiVersoreApiResponse
} from "./types";
import {EmailForm} from "../reports/types";
import AxiosInstanceUpload from "../../components/AxiosUpload";
import * as Yup from "yup";
import {Buffer} from "buffer";
import {format} from "date-fns";
import {columnFiltersParamWithDateRange, sortingParam} from "../../common/Services";

const moment = require('moment')

export function useGetAllReportAgentiVersore(
    pagination: MRT_PaginationState,
    columnFilters: MRT_ColumnFiltersState,
    globalFilter: string,
    sorting: MRT_SortingState,
) {
    return useQuery<ReportAgentiVersoreApiResponse>({


        queryKey: [
            'fetchReportAgentiVersore',
            columnFilters,
            globalFilter,
            pagination.pageIndex,
            pagination.pageSize,
            sorting,
        ],
        queryFn: async () => {
            let codagente = 'NN';
            let coddip = localStorage.getItem('coddip') || 'NN';
            let impcoddip = localStorage.getItem('impcoddip') || 'NN';

            const role = localStorage.getItem('keyrole') || '';
             if (role.includes('TimeReportAdmin')) {
                                codagente = '';
                            } else if (role.includes('TimeReportUser')) {
                                coddip = localStorage.getItem('coddip') || 'NN';
                            } else if (role.includes('TimeReportCust')) {
                                coddip = 'NN';
                            } else if (role.includes('TimeReportAgent')) {
                                try {
                                        const response1 = await AxiosInstance.get(
                                            `agenti/?limit=10&offset=0&VBT10_CODDIP=${coddip}`
                                        );
                                        const agentiResponse = mapJsonToAgentiApiResponse(response1.data)
                                        codagente = agentiResponse?.results[0]?.codagente || '';
                                    } catch (error) {
                                        console.error('Error fetching codagente:', error);
                                        throw new Error('Failed to fetch codagente');
                                    }
                            }

            const myOffset =
                pagination.pageIndex === 0
                    ? '0'
                    : `${pagination.pageSize * pagination.pageIndex}`;

            const myURL = `?limit=${pagination.pageSize}&offset=${myOffset}&search=${globalFilter ?? ''}${columnFiltersParamWithDateRange(
                columnFilters,
                'VBT56'
            )}&ordering=${sortingParam(sorting, 'VBT56')}&VBT56_CODAGENTE=${codagente}`;

            try {
                const response = await AxiosInstance.get(`reportagentiversore/${myURL}`);
                return mapJsonToReportAgentiVersoreApiResponse(response.data);
            } catch (error) {
                console.error('Error fetching data from API:', error);
                throw new Error('Failed to fetch report data');
            }
        },
        refetchOnWindowFocus: false,
    });
}


export function useSendEmail() {
  return useMutation({
    mutationFn: async (emailForm: EmailForm) => {
      return AxiosInstance.post('sendemail/', emailForm);
    },
  });
}

export function useUploadReport() {
  return useMutation({
    mutationFn: async (formData: FormData) => {
      return AxiosInstanceUpload.post('uploadreport/', formData);
    },
  });
}


export const validationSchema = Yup.object().shape({
                      fromDate: Yup.date().required('Selezione Data Inizio'),
                      toDate: Yup.date().test('is-after-or-equal', 'La data di fine deve essere successiva alla data di inizio', function (value) {
                                         const { fromDate } = this.parent; // Access fromDate from parent object
                                         if (!fromDate || !value) {
                                         return true; // Skip validation if fromDate or toDate is not set
                                      }
                                      return fromDate <= value; // Validate if toDate is after or equal to fromDate
                                    }),
                      emailTo: Yup.string().email('Email non è valida'),
                    });




export async function jasperReportAgentiVersoreBlob( fromDate: Date, toDate: Date, ditta: String, codcli: String, formato: String) {
  try {
    const username = 'jasperadmin';
    const password = 'Tibco2024@';
    const base64encodedData = Buffer.from(`${username}:${password}`).toString('base64');

    const fromDateString = fromDate ? format(fromDate, 'yyyy-MM-dd') : '';
    const toDateString = toDate ? format(toDate, 'yyyy-MM-dd') : '';

         let pag = '';
             if (formato === 'xlsx') {
                pag = 'ignorePagination=true&'
            }

    // check codcli = 0 for admin

      const mycodcli = codcli === '0' ? '' : codcli;


    const response = await fetch(`${BASE_URL_JASPERSERVER}/rest_v2/reports/reports/repcliversore${formato}.${formato}?${pag}datainizio=${fromDateString}&datafine=${toDateString}&codcli=${mycodcli}&ditta=${ditta}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/'+formato,
        'Authorization': `Basic ${base64encodedData}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch the report');
    }

    const blob = await response.blob();
    return blob;
  } catch (error) {
    console.error('Error generating report:', error);
    throw error; // Rethrow the error to handle it in the calling code if needed
  }
};
















